export interface IRoute {
	title: string;
	route: any[];
}
